import { Order } from '@/coreDomainsModule/entities/order';
import { UserAccountFactory } from './userAccountFactory';

/**
 * ファクトリー
 */
export class OrderFactory {
  /**
   * 発注情報を生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<Order> = {}): Order => {
    const order: Required<Order> = {
      orderId: initialData.orderId ?? '',
      aggregateBusinessId: initialData.aggregateBusinessId ?? '',
      supplierNumber: initialData.supplierNumber ?? '',
      supplierName: initialData.supplierName ?? '',
      businessNumber: initialData.businessNumber ?? '',
      businessName: initialData.businessName ?? '',
      package: initialData.package ?? 0,
      unit: initialData.unit ?? '',
      manufacturer: initialData.manufacturer ?? '',
      warehouseNumber: initialData.warehouseNumber ?? '',
      warehouse: initialData.warehouse ?? '',
      aggregateBusinessResponsibleUsers: initialData.aggregateBusinessResponsibleUsers ?? [],
      orderIssuedNumber: initialData.orderIssuedNumber,
      orderNumber: initialData.orderNumber ?? '',
      createdOrderDate: initialData.createdOrderDate ?? 0,
      desiredDeliveryDate: initialData.desiredDeliveryDate ?? 0,
      estimatedTimeOfArrival: initialData.estimatedTimeOfArrival ?? 0,
      orderAmount: initialData.orderAmount ?? 0,
      orderStatus: initialData.orderStatus ?? 'Unknown',
      outputDate: initialData.outputDate,
      isOutOfStockExpected: initialData.isOutOfStockExpected,
      userCustomParameters: initialData.userCustomParameters ?? {},
      statusUpdateAt: initialData.statusUpdateAt,
      orderNote: initialData.orderNote ?? '',
      orderGroupId: initialData.orderGroupId,
      orderGroupName: initialData.orderGroupName,
      invoiceNumber: initialData.invoiceNumber,
      destinationName: initialData.destinationName,
      upperLimitQuantity: initialData.upperLimitQuantity ?? 0,
      orderAlert: initialData.orderAlert ?? [],
      partialDeliveries: initialData.partialDeliveries ?? [],
      lastUpdatedByUser: initialData.lastUpdatedByUser ?? UserAccountFactory.create(),
      updatedAt: initialData.updatedAt ?? 0,
      reminderMailDataId: initialData.reminderMailDataId ?? null,
      orderBasisId: initialData.orderBasisId,
      initialOrderAmount: initialData.initialOrderAmount,
      initialDesiredDeliveryDate: initialData.initialDesiredDeliveryDate,
    };
    return order;
  };
}
